<template>
    <div class="col-md-24">
        <div class="row">
            <adminNav></adminNav>
        </div>
        <div class="conversation-component container">
            <div class="row">
                <router-link
                        :to="{ name: 'admin-users-delete-list' }"
                        class="btn btn-link"
                        style="display: block; text-align: center; margin-top: -10px;margin-bottom: 10px;font-size: 16px;"
                    >
                        {{ $t('pedidosDeEliminacionDeCuenta') }}
                    </router-link>
                <div class="col-md-20 col-md-offset-2">
                    <div class="col-sm-8 col-md-8">
                        <div class="conversation_list">
                            <ul class="list-group">
                                <li class="list-group-item">
                                    <div class="up">
                                        <input
                                            v-model="textSearch"
                                            v-on:keyup="onSearchUsers"
                                            type="text"
                                            class="form-control"
                                            :placeholder="$t('escribeUnNombreYPresionaBuscar')"
                                        />
                                    </div>
                                </li>
                                <template v-if="textSearch.length != 0">
                                    <Loading
                                        class="conversation_chat--chats"
                                        :data="userList"
                                    >
                                        <li
                                            v-for="user in userList"
                                            class="list-group-item conversation_header"
                                            @click="selectUser(user)"
                                            v-bind:key="user.id"
                                        >
                                            <div class="media">
                                                <div
                                                    class="media-right pull-right"
                                                >
                                                    <button
                                                        class="btn btn-success btn-circle"
                                                        v-on:click.stop="
                                                            toUserMessages(user)
                                                        "
                                                    >
                                                        <i
                                                            class="fa fa-comments medium-icon"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </button>
                                                </div>
                                                <div class="media-left">
                                                    <div
                                                        class="conversation_image circle-box"
                                                        v-imgSrc:profile="
                                                            user.image
                                                        "
                                                    ></div>
                                                </div>
                                                <div class="media-body">
                                                    <h4 class="media-heading">
                                                        <span
                                                            class="conversation-title"
                                                        >
                                                            {{ user.name }}
                                                        </span>
                                                    </h4>
                                                    <span>
                                                        {{ user.email }}
                                                    </span>
                                                    <span
                                                        style="display: block"
                                                    >
                                                        {{ user.nro_doc }} -
                                                        {{ user.mobile_phone }}
                                                    </span>
                                                    <span
                                                        style="display: block"
                                                    >
                                                        {{
                                                            user.last_connection
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </li>
                                        <template #no-data><li
                                            class="list-group-item alert alert-warning"
                                            role="alert"
                                        >
                                            {{ $t('noSeEncontroNingunUsuario') }}
                                        </li></template>
                                        <template #loading><li
                                            class="list-group-item alert alert-info"
                                            role="alert"
                                        >
                                            <img
                                                src="https://carpoolear.com.ar/static/img/loader.gif"
                                                alt=""
                                                class="ajax-loader"
                                            />
                                            {{ $t('cargandoUsuarios') }}
                                        </li></template>
                                    </Loading>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div
                        v-if="currentUser"
                        class="user-settings col-xs-24 col-sm-16 col-md-16"
                    >
                        <div class="settings-container">
                            <div class="form-group">
                                <label for="input-name"
                                    >{{ $t('nombreYApellido') }}</label
                                >
                                <input
                                    maxlength="25"
                                    v-model="newInfo.name"
                                    type="text"
                                    class="form-control"
                                    id="input-name"
                                    :placeholder="$t('nombre')"
                                />
                                <span class="error" v-if="nombreError.state">
                                    {{ nombreError.message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="input-email">{{ $t('eMail') }}</label>
                                <input
                                    maxlength="40"
                                    v-model="newInfo.email"
                                    type="text"
                                    class="form-control"
                                    id="input-email"
                                    :placeholder="$t('eMail')"
                                />
                            </div>

                            <div class="form-group">
                                <label for="input-description"
                                    >{{ $t('acercaDeMi') }}</label
                                >
                                <textarea
                                    maxlength="1000"
                                    v-model="newInfo.description"
                                    :placeholder="$t('descripcion')"
                                ></textarea>
                                <span
                                    class="error textarea"
                                    v-if="descError.state"
                                >
                                    {{ descError.message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="input-private-note"
                                    >{{ $t('notaPrivada') }}</label
                                >
                                <textarea
                                    maxlength="1000"
                                    v-model="newInfo.private_note"
                                    :placeholder="$t('notaSoloVisiblePorAdmins')"
                                ></textarea>
                            </div>

                            <div class="form-group">
                                <label for="input-dni"
                                    >{{ $t('numeroDeDocumento') }}</label
                                >
                                <input
                                    type="tel"
                                    v-model="newInfo.nro_doc"
                                    @input="handleDniInput"
                                    class="form-control"
                                    id="input-dni"
                                    :placeholder="$t('doc')"
                                    :maxlength="(settings.profile_id_format).length"
                                />
                                <span class="error" v-if="dniError.state">
                                    {{ dniError.message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="input-telefono"
                                    >{{ $t('numeroDeTelefono') }}</label
                                >
                                <input
                                    maxlength="20"
                                    @keydown="isNumber"
                                    v-on:paste="isNumber"
                                    v-model="newInfo.mobile_phone"
                                    type="tel"
                                    class="form-control"
                                    id="input-phone"
                                    :placeholder="$t('numeroDeTelefonoAlMenos7Numeros')"
                                />
                                <span class="error" v-if="phoneError.state">
                                    {{ phoneError.message }}
                                </span>
                            </div>

                            <div class="form-group">
                                <label for="input-patente"
                                    >{{ $t('patente') }}</label
                                >
                                <input
                                    maxlength="20"
                                    v-model="newInfo.patente"
                                    type="text"
                                    class="form-control"
                                    id="input-patente"
                                    :class="{ 'has-error': patenteError.state }"
                                    :placeholder="$t('patente')"
                                />
                                <span class="error" v-if="patenteError.state">
                                    {{ patenteError.message }}
                                </span>
                            </div>

                            <div
                                v-if="newInfo.identity_validated_at"
                                class="form-group"
                            >
                                <label>{{ $t('identidadValidada') }}</label>
                                <p class="text-muted">
                                    {{ $t('identidadValidadaTooltip') }}
                                </p>
                                <button
                                    type="button"
                                    class="btn btn-warning"
                                    :disabled="clearingIdentity"
                                    @click="confirmClearIdentityValidation"
                                >
                                    {{ $t('removerValidacionIdentidad') }}
                                </button>
                            </div>

                            <div class="form-group">
                                <label for="input-pass"
                                    >{{ $t('ingreseSuNuevaContrasena') }}</label
                                >
                                <input
                                    maxlength="40"
                                    v-model="newInfo.pass.password"
                                    type="password"
                                    class="form-control"
                                    id="input-pass"
                                    :placeholder="$t('contrasena')"
                                    autocomplete="new-password"
                                />
                                <input
                                    maxlength="40"
                                    v-model="newInfo.pass.password_confirmation"
                                    type="password"
                                    class="form-control"
                                    id="input-pass-confirm"
                                    :placeholder="$t('repetirContrasena')"
                                    autocomplete="new-password"
                                />
                                <span class="error" v-if="passError.state">
                                    {{ phoneError.message }}
                                </span>
                            </div>
                            <hr />
                            <div
                                class="row"
                                v-if="
                                    newInfo.driver_data_docs &&
                                    newInfo.driver_data_docs.length &&
                                    settings.module_validated_drivers
                                "
                            >
                                <h4 class="col-xs-24">
                                    {{ $t('documentacionDelChofer') }}
                                </h4>
                                <div
                                    v-imgSrc:docs="img"
                                    v-for="img in newInfo.driver_data_docs"
                                    class="img-doc col-md-8 col-sm-12"
                                ></div>
                            </div>
                            <div
                                class="form-group"
                                v-if="settings.module_validated_drivers"
                            >
                                <label for="tipoDeCuenta">
                                    {{ $t('tipoDeCuenta') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                    >
                                        (*)
                                    </span>
                                </label>
                                <select
                                    v-model="newInfo.account_type"
                                    id="tipoDeCuenta"
                                    class="form-control"
                                >
                                    <option
                                        v-for="option in accountTypes"
                                        v-bind:value="option.id"
                                    >
                                        {{ option.name }}
                                    </option>
                                </select>
                                <span
                                    class="error"
                                    v-if="accountTypeError.state"
                                >
                                    {{ accountTypeError.message }}
                                </span>
                            </div>
                            <div
                                class="form-group"
                                v-if="settings.module_validated_drivers"
                            >
                                <label for="bancoDeCuenta">
                                    {{ $t('bancoDeCuenta') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                    >
                                        (*)
                                    </span>
                                </label>
                                <select
                                    v-model="newInfo.account_bank"
                                    id=""
                                    class="form-control"
                                >
                                    <option
                                        v-for="option in banks"
                                        v-bind:value="option.id"
                                    >
                                        {{ option.name }}
                                    </option>
                                </select>
                                <span
                                    class="error"
                                    v-if="accountBankError.state"
                                >
                                    {{ accountBankError.message }}
                                </span>
                            </div>
                            <div
                                class="form-group"
                                v-if="settings.module_validated_drivers"
                            >
                                <label for="accountNumber">
                                    {{ $t('numeroDeCuenta') }}
                                    <span
                                        class="required-field-flag"
                                        :title="$t('tituloCampoRequerido')"
                                    >
                                        (*)
                                    </span>
                                </label>
                                <input
                                    v-model="newInfo.account_number"
                                    type="text"
                                    class="form-control"
                                    id="accountNumber"
                                    :placeholder="$t('numeroDeCuenta')"
                                />
                                <span
                                    class="error"
                                    v-if="accountNumberError.state"
                                >
                                    {{ accountNumberError.message }}
                                </span>
                            </div>
                            <div
                                class="checkbox"
                                v-if="settings.module_validated_drivers"
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="newInfo.driver_is_verified"
                                    />
                                    {{ $t('esChofer') }}
                                </label>
                            </div>
                            <hr />
                            <div class="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="newInfo.active"
                                    />
                                    {{ $t('usuarioActivo') }}
                                </label>
                            </div>

                            <div class="row">
                                <div class="checkbox col-md-19">
                                    <label>
                                        <input
                                                type="checkbox"
                                                v-model="newInfo.banned"
                                            />
                                        {{ $t('usuarioSuspendido') }}
                                    </label>
                                </div>
                                <div class="col-md-5 text-right">
                                    <button
                                        class="btn btn-primary"
                                        v-on:click="save"
                                    >
                                        {{ $t('grabar') }}
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <div class="row" style="margin-top: 1em;">
                                <div class="col-md-24">
                                    <button
                                        class="btn btn-danger btn-sm"
                                        v-on:click="openConfirmModal('delete')"
                                        style="margin-right: 8px;"
                                    >
                                        {{ $t('eliminarUsuario') }}
                                    </button>
                                    <button
                                        class="btn btn-warning btn-sm"
                                        v-on:click="openConfirmModal('anonymize')"
                                        style="margin-right: 8px;"
                                    >
                                        {{ $t('anonimizarUsuario') }}
                                    </button>
                                    <button
                                        class="btn btn-warning btn-sm"
                                        v-on:click="openConfirmModal('banAndAnonymize')"
                                    >
                                        {{ $t('anonimizarYBloquearUsuario') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="col-xs-24 col-sm-16 col-md-16">
                        <p
                            class="alert alert-warning"
                            role="alert"
                        >
                            {{ $t('seleccioneAlgunaPersona') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <modal
            v-if="showConfirmModal"
            :name="'modal-confirm-admin-action'"
            @close="closeConfirmModal"
        >
            <template #header><h3>
                <span>{{ confirmModalTitle }}</span>
                <i v-on:click="closeConfirmModal" class="fa fa-times float-right-close"></i>
            </h3></template>
            <template #body><div>
                <div class="text-left color-black">
                    <p>{{ confirmModalMessage }}</p>
                    <div v-if="pendingAction === 'banAndAnonymize'" class="form-group">
                        <label>{{ $t('nota') }} ({{ $t('opcional') }})</label>
                        <input v-model="banNote" type="text" class="form-control" />
                    </div>
                    <div class="text-center" style="margin-top: 1.5em;">
                        <button
                            class="btn btn-danger"
                            @click="executePendingAction"
                            :disabled="loadingAction"
                        >
                            <span v-if="!loadingAction">{{ $t('confirmar') }}</span>
                            <spinner v-if="loadingAction" class="blue"></spinner>
                        </button>
                        <button class="btn btn-default" @click="closeConfirmModal" style="margin-left: 8px;">
                            {{ $t('cancelar') }}
                        </button>
                    </div>
                </div>
            </div></template>
        </modal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { Thread } from '../../classes/Threads.js';
import Loading from '../Loading.vue';
import { inputIsNumber, formatId, cleanId } from '../../services/utility';
import dialogs from '../../services/dialogs.js';
import router from '../../router';
import adminNav from '../sections/adminNav';
import modal from '../Modal';
import Spinner from '../Spinner.vue';
import { AdminApi, UserApi } from '../../services/api';

export default {
    // TODO fix css names
    // TODO search by facebook
    name: 'admin-users',
    data() {
        return {
            textSearch: '',
            userList: [],
            currentUser: '',
            newInfo: {
                name: '',
                email: '',
                description: '',
                private_note: '',
                nro_doc: '',
                mobile_phone: '',
                pass: {},
                active: '',
                banned: '',
                driver_is_verified: 0,
                driver_data_docs: [],
                account_number: '',
                account_type: '',
                account_bank: '',
                cars: [],
                patente: ''
            },
            error: null,
            globalError: false,
            nombreError: new Error(),
            descError: new Error(),
            passError: new Error(),
            dniError: new Error(),
            phoneError: new Error(),
            emailError: new Error(),
            accountNumberError: new Error(),
            accountTypeError: new Error(),
            accountBankError: new Error(),
            patenteError: new Error(),
            keyUpTimerId: 0,
            banks: [],
            accountTypes: [],
            showConfirmModal: false,
            pendingAction: null,
            loadingAction: false,
            adminApi: null,
            banNote: '',
            clearingIdentity: false
        };
    },

    computed: {
        ...mapGetters({
            isMobile: 'device/isMobile',
            settings: 'auth/appConfig'
        }),
        confirmModalTitle() {
            if (this.pendingAction === 'delete') return this.$t('confirmarEliminarUsuario');
            if (this.pendingAction === 'anonymize') return this.$t('confirmarAnonimizarUsuario');
            if (this.pendingAction === 'banAndAnonymize') return this.$t('confirmarAnonimizarYBloquearUsuario');
            return '';
        },
        confirmModalMessage() {
            if (this.pendingAction === 'delete') return this.$t('confirmarEliminarUsuarioMensaje');
            if (this.pendingAction === 'anonymize') return this.$t('confirmarAnonimizarUsuarioMensaje');
            if (this.pendingAction === 'banAndAnonymize') return this.$t('confirmarAnonimizarYBloquearUsuarioMensaje');
            return '';
        }
    },

    methods: {
        ...mapActions({
            update: 'admin/adminUpdate',
            search: 'admin/searchUsers',
            lookConversation: 'conversations/createConversation',
            getBankData: 'profile/getBankData'
        }),

        onSearchUsers() {
            if (this.keyUpTimerId) {
                clearTimeout(this.keyUpTimerId);
            }
            this.keyUpTimerId = setTimeout(() => {
                this.search(this.textSearch).then((data) => {
                    this.userList = data.data;
                    // console.log('pas');
                    // FIXME seleccionar usuario a veces congela la lista
                });
            }, 750);
        },
        confirmClearIdentityValidation() {
            if (!this.currentUser || !this.currentUser.id) return;
            if (!confirm(this.$t('confirmarRemoverValidacionIdentidad'))) return;
            this.doClearIdentityValidation();
        },
        doClearIdentityValidation() {
            if (!this.currentUser || !this.currentUser.id) return;
            this.clearingIdentity = true;
            const api = new AdminApi();
            api.clearIdentityValidation(this.currentUser.id)
                .then(() => {
                    this.newInfo.identity_validated = false;
                    this.newInfo.identity_validated_at = null;
                    this.currentUser.identity_validated = false;
                    this.currentUser.identity_validated_at = null;
                    dialogs.message(this.$t('validacionIdentidadRemovida'));
                })
                .catch(() => {
                    dialogs.message(this.$t('resultError'), { estado: 'error' });
                })
                .finally(() => {
                    this.clearingIdentity = false;
                });
        },
        selectUser(user) {
            this.currentUser = user;
            console.log('selectUser', user);
            // Ensure nro_doc is stored as raw value (no dots) when loaded from backend
            const nroDocRaw = this.currentUser.nro_doc
                ? cleanId(this.currentUser.nro_doc, this.settings.profile_id_format)
                : '';
            this.newInfo = {
                name: this.currentUser.name,
                email: this.currentUser.email,
                description: this.currentUser.description,
                private_note: this.currentUser.private_note,
                nro_doc: nroDocRaw,
                mobile_phone: this.currentUser.mobile_phone,
                pass: {},
                user: {},
                driver_is_verified: this.currentUser.driver_is_verified,
                driver_data_docs: this.currentUser.driver_data_docs,
                account_number: this.currentUser.account_number,
                account_type: this.currentUser.account_type,
                account_bank: this.currentUser.account_bank,
                banned: this.currentUser.banned > 0,
                active: this.currentUser.active > 0,
                cars: this.currentUser.cars || [],
                patente: this.currentUser.cars && this.currentUser.cars.length > 0 ? this.currentUser.cars[0].patente : '',
                identity_validated: this.currentUser.identity_validated,
                identity_validated_at: this.currentUser.identity_validated_at
            };
            // Format nro_doc for display after loading
            if (this.newInfo.nro_doc) {
                this.newInfo.nro_doc = formatId(this.newInfo.nro_doc, this.settings.profile_id_format);
            }
        },
        toUserMessages(user) {
            console.log('toUserMessages');
            this.lookConversation({ user: user, tripId: null }).then(
                (conversation) => {
                    console.log('toUserMessages then', conversation);
                    router.push({
                        name: 'conversation-chat',
                        params: { id: conversation.id }
                    });
                }
            );
        },

        isNumber(value) {
            inputIsNumber(value);
        },

        // Handle DNI input - format using pattern
        handleDniInput(event) {
            const formatted = formatId(event.target.value, this.settings.profile_id_format);
            event.target.value = formatted;
            // Update the Vue data model with the formatted value
            this.newInfo.nro_doc = formatted;
        },

        clear() {
            this.currentUser = '';
            this.newInfo = {
                name: '',
                email: '',
                description: '',
                private_note: '',
                nro_doc: '',
                mobile_phone: '',
                pass: {},
                active: '',
                banned: '',
                driver_is_verified: 0,
                driver_data_docs: [],
                account_number: '',
                account_type: '',
                account_bank: '',
                cars: [],
                patente: ''
            };
        },
        loadUserFromQuery() {
            const userId = this.$route.query.userId;
            if (!userId) return;
            this.userApi.show(userId).then((response) => {
                const user = response.data;
                if (user) {
                    this.selectUser(user);
                    this.textSearch = user.name || '';
                    this.userList = [user];
                }
            }).catch(() => {
                dialogs.message(this.$t('noSeEncontroNingunUsuario'), { estado: 'error' });
            });
        },
        conversationsSearch() {
            // Placeholder method - may be implemented later
        },
        unreadMessage() {
            // Placeholder method - may be implemented later
        },
        select(user) {
            if (user) {
                this.selectUser(user);
            } else {
                this.clear();
            }
        },
        openConfirmModal(action) {
            this.pendingAction = action;
            this.banNote = '';
            this.showConfirmModal = true;
        },
        closeConfirmModal() {
            this.showConfirmModal = false;
            this.pendingAction = null;
            this.banNote = '';
        },
        executePendingAction() {
            if (!this.currentUser || !this.currentUser.id) return;
            this.loadingAction = true;
            const api = this.adminApi;
            let promise;
            if (this.pendingAction === 'delete') {
                promise = api.deleteUser(this.currentUser.id);
            } else if (this.pendingAction === 'anonymize') {
                promise = api.anonymizeUser(this.currentUser.id);
            } else if (this.pendingAction === 'banAndAnonymize') {
                promise = api.banAndAnonymizeUser(this.currentUser.id, this.banNote);
            } else {
                this.loadingAction = false;
                return;
            }
            const userId = this.currentUser.id;
            promise
                .then(() => {
                    this.loadingAction = false;
                    this.closeConfirmModal();
                    this.clear();
                    this.userList = this.userList.filter((u) => u.id !== userId);
                    dialogs.message(this.$t('accionCompletadaExitosamente'), {
                        duration: 5,
                        estado: 'success'
                    });
                })
                .catch((err) => {
                    this.loadingAction = false;
                    const msg = (err.response && err.response.data && err.response.data.message) || err.message || this.$t('errorAlActualizar');
                    dialogs.message(msg, {
                        duration: 5,
                        estado: 'error'
                    });
                    if (err.response && err.response.data && err.response.data.error === 'requires_ban') {
                        this.closeConfirmModal();
                    }
                });
        },
        validate() {
            let globalError = false;
            this.nombreError = new Error();
            this.descError = new Error();
            this.passError = new Error();
            this.dniError = new Error();
            this.emailError = new Error();
            this.phoneError = new Error();
            this.accountNumberError = new Error();
            this.accountTypeError = new Error();
            this.accountBankError = new Error();
            this.patenteError = new Error();

            /* if (!this.newInfo.name || this.newInfo.name.length < 1) {
                this.nombreError.state = true;
                this.nombreError.message = 'Olvidaste ingresar tu nombre y apellido.';
                globalError = true;
            }

            if (!this.newInfo.description || this.newInfo.description.length < 1) {
                this.descError.state = true;
                this.descError.message = 'Olvidaste completar tu descripción.';
                globalError = true;
            } else if (this.newInfo.description.replace(' ', '').length < 10) {
                this.descError.state = true;
                this.descError.message = 'Ups! Tu descripción es muy acotada. No seas tímido, contanos un poco más.';
                globalError = true;
            }

            if (this.newInfo.nro_doc && this.newInfo.nro_doc.length > 0 && this.newInfo.nro_doc.length < 7) {
                // this.dniError.state = true;
                // this.dniError.message = 'El DNI que ingresaste no es válido.';
                this.$set(this.dniError, 'state', true);
                this.$set(this.dniError, 'message', 'asdasdasdasd');

                globalError = true;
            }

            if (this.newInfo.mobile_phone && this.newInfo.mobile_phone.length > 0 && this.newInfo.mobile_phone.length < 6) {
                this.phoneError.state = true;
                this.phoneError.message = 'El teléfono que ingresaste no es válido.';
                globalError = true;
            }

            if (this.newInfo.pass.password && this.newInfo.pass.password !== this.newInfo.pass.password_confirmation) {
                this.passError = this.$t('passwordNoCoincide');
                globalError = true;
            } */

            // Validate patente if provided - allow all strings
            if (this.newInfo.patente && this.newInfo.patente.length > 0) {
                // Basic validation: just check it's not empty and has reasonable length
                if (this.newInfo.patente.length > 20) {
                    this.patenteError.state = true;
                    this.patenteError.message = this.$t('patenteNoValida');
                    globalError = true;
                }
            }

            console.log('error', this);

            if (globalError) {
                this.$forceUpdate();
            }
            return globalError;
        },

        save() {
            if (!this.validate()) {
                // DNI: send raw value without dots (backend expects digits only)
                const nroDocRaw = this.newInfo.nro_doc
                    ? cleanId(this.newInfo.nro_doc, this.settings.profile_id_format)
                    : this.newInfo.nro_doc;

                // Patente: trim whitespace before sending
                const patenteValue = (this.newInfo.patente && this.newInfo.patente.trim) ? this.newInfo.patente.trim() : (this.newInfo.patente || '');

                // Only send properties from the admin form (backend allows these for admin)
                const payload = {
                    user: { id: this.currentUser.id },
                    name: this.newInfo.name,
                    email: this.newInfo.email,
                    description: this.newInfo.description,
                    private_note: this.newInfo.private_note,
                    nro_doc: nroDocRaw,
                    mobile_phone: this.newInfo.mobile_phone,
                    patente: patenteValue,
                    driver_is_verified: this.newInfo.driver_is_verified ? 1 : 0,
                    account_number: this.newInfo.account_number,
                    account_type: this.newInfo.account_type,
                    account_bank: this.newInfo.account_bank,
                    banned: this.newInfo.banned ? 1 : 0,
                    active: this.newInfo.active ? 1 : 0
                };

                if (this.newInfo.pass && this.newInfo.pass.password) {
                    payload.password = this.newInfo.pass.password;
                    payload.password_confirmation = this.newInfo.pass.password_confirmation;
                }

                this.update(payload)
                    .then(() => {
                        dialogs.message(this.$t('perfilActualizadoCorrectamente'));
                    })
                    .catch((err) => {
                        console.log(err);
                        let mensajeErr = this.$t('errorAlActualizar');
                        for (const key in err.errors) {
                            if (Object.hasOwnProperty.call(err.errors, key)) {
                                mensajeErr += err.errors[key] + ' ';
                            }
                        }
                        dialogs.message(mensajeErr, {
                            duration: 10,
                            estado: 'error'
                        });
                    });
                this.onSearchUsers();
            } else {
                dialogs.message(this.$t('verifiqueLosCampos'), { estado: 'error' });
            }
        }
    },

    beforeDestroy() {
        this.thread.stop();
        this.select(null);
    },

    watch: {
        isMobile: function () {
            if (!this.isMobile) {
                // router.push({ name: 'conversation-chat' });
            }
        },
        textSearch: function (newValue, oldValue) {
            if (oldValue.length === 0 && newValue.length > 0) {
                this.clear();
            }
        },
        'newInfo.patente': function () {
            this.patenteError.state = false;
        }
    },

    mounted() {
        this.adminApi = new AdminApi();
        this.userApi = new UserApi();
        this.getBankData().then((data) => {
            console.log('get bank data', data);
            this.banks = data.banks;
            this.accountTypes = data.cc;
        });
        this.conversationsSearch();
        this.thread = new Thread(() => {
            this.unreadMessage();
        });
        this.thread.run(20000);
        this.loadUserFromQuery();
    },
    watch: {
        '$route.query.userId'(userId) {
            this.loadUserFromQuery();
        }
    },
    updated() {},
    components: {
        Loading,
        adminNav,
        modal,
        Spinner
    }
};
</script>

<style scoped>
.medium-icon {
    font-size: 1.5em;
}

.bottom-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.settings-container {
    padding: 10px;
}

.user-settings {
    background-color: #fff;
    border: 1px solid #dddddd;
}

.app-container.white {
    background-color: #fff;
}
.conversation-component.container {
    width: auto;
}
.conversation_chat p,
.message_text {
    font-size: 13px;
}
.conversation_chat h2 {
    font-size: 25px;
    margin-top: 0.2em;
    margin-bottom: 0;
}
.chat_last_connection {
    margin: 0.4rem 0;
}

.btn-full-width {
    width: 100%;
    margin: 0 0 0.8em 0;
}

.message-wrapper {
    text-align: left;
    margin-bottom: 0.4em;
}
.conversation-component.container {
    margin-bottom: 3rem;
}
.conversation_chat--search > li {
    color: #009ce1;
    cursor: pointer;
}
.conversation_chat--search > li:hover {
    background-color: #eee;
}
.conversation_chat--search li.list-group-item:last-child {
    border-bottom-width: 1px;
}
.conversation-title {
    font-size: 14px;
}
.list-group-item {
    font-size: 14px;
}
.list-group-item.unread,
.list-group-item.unread:hover,
.list-group-item.unread:focus {
    background: rgba(254, 153, 0, 0.25);
}

.conversation_chat,
.conversation_chat > div,
.conversation-component.container .row,
.conversation-component > .row > div,
.conversation-component > .row > div > div,
.conversation_list .list-group {
    height: auto;
}

.form-control {
    margin-bottom: 0px;
}
.conversation-component.container {
    height: auto;
    overflow-y: auto;
}
.img-doc {
    height: 320px;
    background-size: cover;
}

@media only screen and (min-width: 768px) {
    .conversation-title {
        font-size: 18px;
    }
    .conversation_chat p,
    .message_text {
        font-size: 14px;
    }
    .conversation_chat h2 {
        font-size: 22px;
    }
    .conversation_chat p.chat_last_connection {
        font-size: 13px;
        margin: 0;
    }
    .app-container {
        background-color: transparent;
    }

    .conversation-component > .row {
        padding-left: 20px;
        padding-right: 20px;
    }
}
</style>
